import React from 'react';
import SEO from '../components/SEO';

const TermsOfService = () => {
  return (
    <div className="min-h-screen pt-24 bg-[#f7f5f2]">
      <SEO title="Terms and Conditions" description="Speaking Mirror Terms and Conditions — governing your access to and use of our website and services." />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-[#1e1919] mb-2">Terms and Conditions</h1>
        <p className="text-[#736c64] text-sm mb-10">© 2026 Speaking Mirror. All Rights Reserved.</p>

        <div className="prose prose-lg max-w-none text-[#1e1919] space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">1. Introduction</h2>
            <p className="text-[#736c64] leading-relaxed">Welcome to Speaking Mirror.</p>
            <p className="text-[#736c64] leading-relaxed">These Terms and Conditions govern your access to and use of the Speaking Mirror website located at https://www.speakingmirror.in and any related services, content, features, or communications provided through the website.</p>
            <p className="text-[#736c64] leading-relaxed">By accessing or using this website, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these Terms, you should discontinue use of the website immediately.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">2. Website Use</h2>
            <p className="text-[#736c64] leading-relaxed mb-2">You agree to use this website only for lawful purposes and in accordance with these Terms and Conditions. You agree not to:</p>
            <ul className="list-disc pl-6 text-[#736c64] space-y-1">
              <li>Use the website in any manner that violates applicable laws or regulations.</li>
              <li>Attempt to gain unauthorized access to any portion of the website, servers, or systems.</li>
              <li>Introduce viruses, malware, or any harmful technology.</li>
              <li>Interfere with the proper operation, functionality, or security of the website.</li>
              <li>Use automated tools, bots, or scraping technologies without prior authorization.</li>
            </ul>
            <p className="text-[#736c64] leading-relaxed mt-2">Speaking Mirror reserves the right to restrict or terminate access to users who violate these Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">3. Intellectual Property Rights</h2>
            <p className="text-[#736c64] leading-relaxed mb-2">Unless otherwise stated, all content available on this website, including but not limited to text, graphics, logos, branding elements, images, videos, audio content, website design, layouts, and marketing materials are the intellectual property of Speaking Mirror and are protected under applicable copyright, trademark, and intellectual property laws.</p>
            <p className="text-[#736c64] leading-relaxed">No material from this website may be copied, reproduced, distributed, modified, republished, transmitted, displayed, or otherwise used without prior written permission from Speaking Mirror.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">4. Information Accuracy</h2>
            <p className="text-[#736c64] leading-relaxed">While Speaking Mirror strives to ensure that all information presented on this website is accurate, current, and reliable, we make no warranties or representations regarding the completeness, accuracy, or suitability of any information published on the website.</p>
            <p className="text-[#736c64] leading-relaxed mt-2">Content may be updated, modified, or removed without prior notice.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">5. Third-Party Links</h2>
            <p className="text-[#736c64] leading-relaxed">This website may contain links to third-party websites for informational or convenience purposes. Speaking Mirror does not endorse, control, or assume responsibility for the content, privacy practices, availability, or accuracy of any third-party websites.</p>
            <p className="text-[#736c64] leading-relaxed mt-2">Users access external websites at their own risk.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">6. User Submissions</h2>
            <p className="text-[#736c64] leading-relaxed mb-2">By submitting information through contact forms, inquiry forms, email communications, or other channels available on this website, you agree that:</p>
            <ul className="list-disc pl-6 text-[#736c64] space-y-1">
              <li>The information provided is accurate and truthful.</li>
              <li>You have the authority to submit such information.</li>
              <li>The information does not violate any applicable law or third-party rights.</li>
            </ul>
            <p className="text-[#736c64] leading-relaxed mt-2">Speaking Mirror reserves the right to refuse, remove, or disregard any submission that is unlawful, inappropriate, misleading, or harmful.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">7. Privacy and Data Protection</h2>
            <p className="text-[#736c64] leading-relaxed">Your use of this website is also governed by our Privacy Policy. By using the website, you acknowledge that you have read and understood our Privacy Policy and consent to the collection and use of information as described therein.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">8. Disclaimer</h2>
            <p className="text-[#736c64] leading-relaxed">The information and content provided on this website are for general informational purposes only. Speaking Mirror does not guarantee specific business outcomes, marketing results, lead generation performance, search engine rankings, advertising success, revenue growth, or any other commercial results arising from the use of information available on this website.</p>
            <p className="text-[#736c64] leading-relaxed mt-2">Any reliance placed on website content is strictly at the user's own discretion and risk.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">9. Limitation of Liability</h2>
            <p className="text-[#736c64] leading-relaxed mb-2">To the fullest extent permitted by applicable law, Speaking Mirror shall not be liable for any direct, indirect, incidental, consequential, special, or punitive damages arising from:</p>
            <ul className="list-disc pl-6 text-[#736c64] space-y-1">
              <li>Access to or use of the website.</li>
              <li>Inability to access or use the website.</li>
              <li>Errors, omissions, or inaccuracies in website content.</li>
              <li>Technical interruptions or downtime.</li>
              <li>Unauthorized access to user information.</li>
              <li>Third-party actions or external website links.</li>
            </ul>
            <p className="text-[#736c64] leading-relaxed mt-2">Your use of this website is entirely at your own risk.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">10. Website Availability</h2>
            <p className="text-[#736c64] leading-relaxed">Speaking Mirror reserves the right to modify, suspend, restrict, or discontinue any portion of the website, services, features, or content at any time without prior notice. We do not guarantee uninterrupted or error-free access to the website.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">11. Indemnification</h2>
            <p className="text-[#736c64] leading-relaxed mb-2">You agree to indemnify, defend, and hold harmless Speaking Mirror, its directors, employees, affiliates, partners, and representatives from any claims, damages, liabilities, losses, costs, or expenses arising from:</p>
            <ul className="list-disc pl-6 text-[#736c64] space-y-1">
              <li>Your use of the website.</li>
              <li>Your violation of these Terms and Conditions.</li>
              <li>Your infringement of any third-party rights.</li>
              <li>Any unlawful activity conducted through your use of the website.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">12. Changes to These Terms</h2>
            <p className="text-[#736c64] leading-relaxed">Speaking Mirror reserves the right to revise or update these Terms and Conditions at any time. Any modifications will become effective immediately upon publication on this page. Continued use of the website following any updates constitutes acceptance of the revised Terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">13. Governing Law and Jurisdiction</h2>
            <p className="text-[#736c64] leading-relaxed">These Terms and Conditions shall be governed by and interpreted in accordance with the laws of India. Any disputes arising from or relating to the use of this website shall be subject to the exclusive jurisdiction of the competent courts located in Kolkata, West Bengal, India.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e1919] mb-3">14. Contact Information</h2>
            <p className="text-[#736c64] leading-relaxed">If you have any questions regarding these Terms and Conditions, please contact us:</p>
            <div className="text-[#736c64] leading-relaxed mt-3">
              <p><strong className="text-[#1e1919]">Speaking Mirror</strong></p>
              <p>Jasmine Towers, Suites 201 & 202, 31, Shakespeare Sarani, Kolkata, West Bengal 700017, India</p>
              <p>Email: team@speakingmirror.in</p>
              <p>Phone: +91 9830471770</p>
              <p>Website: https://www.speakingmirror.in</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
